module.exports = __webpack_public_path__ + "img/projects.216690ec.png";